module.exports = __webpack_public_path__ + "static/media/logo-01.c1e1e7b0.png";